import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { AuthService } from './modules/auth/auth.service';
import { WtStorageService } from './wt-storage.service';
import { EmployeeService } from './services/employee.service';
import { AgentClient, KasaClient, UserProfile, UserRoleTypes } from './web-api-client';
import { forkJoin } from 'rxjs';
import { LayoutService } from './services/layout.service';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { NavService } from './services/nav.service';
import * as feather from 'feather-icons';
import { slider } from './animations/route-animation';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slider],
})
export class AppComponent implements OnInit{

  public isloaded: boolean = false;
  public isAnona: boolean = false;

  title = 'app';
  userProfile: UserProfile;
  constructor(public navServices: NavService,
    public layout: LayoutService,
    private changeRef: ChangeDetectorRef,
    public route: ActivatedRoute,
    public readonly changeDetectionRef: ChangeDetectorRef, public router: Router, private readonly authService: AuthService,private readonly employeeService:EmployeeService,public readonly kasaClient:KasaClient,public agentClient:AgentClient,private localStorage:WtStorageService){

  }
  ngOnInit(): void {



    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/anona') {
          this.isloaded= true;
          this.isAnona = true;
          this.changeDetectionRef.detectChanges();
        }
        else if (event.url === '/login') {
          // Login page doesn't need loading spinner
          this.isloaded = true;
          this.isAnona = false;
          this.changeDetectionRef.detectChanges();
        }
        else{
          this.authService.init();
          // Only load user profile if authenticated
          if (this.authService.isAuthenticated()) {
            this.LoadUserProfile();
          }

        }
      }
      if (event instanceof NavigationStart) {
        if (event.url === '/anona') {
          this.isloaded = true;
          this.isAnona = true;
          this.changeDetectionRef.detectChanges();
        }
        else if (event.url === '/login') {
          // Login page doesn't need loading spinner
          this.isloaded = true;
          this.isAnona = false;
          this.changeDetectionRef.detectChanges();
        }
        else {
          this.authService.init();
          // Only load user profile if authenticated
          if (this.authService.isAuthenticated()) {
            this.LoadUserProfile();
          }

        }
      }

    });



    this.authService.isAuthenticated$.subscribe(isAuthenticated => {

        if (isAuthenticated) {

          this.LoadUserProfile();

        }
    });
  }


  private LoadUserProfile() {

    this.employeeService.getCurrentUser().subscribe(user => {
      this.localStorage.setuser(user);
      this.userProfile = user;

      this.agentClient.getCurrent().subscribe(agent => {

        this.localStorage.setАgent(agent);

        this.kasaClient.getCurrent().subscribe(kasa => {
          this.localStorage.setkasa(kasa);

          this.isloaded = true;
          if (this.router.url === '/') {

            void this.router.navigateByUrl(this.router.url+'home');

            /*this.router.navigate(['/home']);*/
           /* window.location.href = '/home';*/
          }

          this.changeDetectionRef.detectChanges();

        })

      })



    });

    }

  public isAuthenticated():boolean {
    return this.userProfile != null;
  }

  public isGlobalAdmin(): boolean {
    return this.userProfile && this.userProfile.userRole == UserRoleTypes.Global_Admin;
  }

  footerDark: any;
  footerLight: any;
  footerFix: any;
  Scorlled: any;
  public show: boolean = true;
  public width = window.innerWidth;
  public screenwidth: any = window.innerWidth;


  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenwidth = event.target.innerWidth;

    if (this.screenwidth < 991) {
      return (this.layout.config.settings.sidebar = 'compact-wrapper');
    } else {
      return (this.layout.config.settings.sidebar =
        this.layout.config.settings.sidebar || 'horizontal-wrapper');
    }
  }

  ngAfterViewInit() {
    this.changeRef.detectChanges();
    setTimeout(() => {
      feather.replace();
    });
  }

  public getRouterOutletState(outlet: any) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  ngDoCheck() {
    if (window.location.pathname == '/page-layout/footer-dark') {
      this.footerDark = true;
      this.footerLight = false;
      this.footerFix = false;
      this.Scorlled = false;
    } else if (window.location.pathname == '/page-layout/footer-light') {
      this.footerLight = true;
      this.footerDark = false;
      this.footerFix = false;
      this.Scorlled = false;
    } else if (window.location.pathname == '/page-layout/footer-fixed') {
      this.footerFix = true;
      this.footerLight = false;
      this.footerDark = false;
      this.Scorlled = false;
    } else if (window.location.pathname == '/page-layout/hide-nav-scroll') {
      this.Scorlled = true;
      this.footerFix = false;
      this.footerLight = false;
      this.footerDark = false;
    }
  }

  @HostListener('window:scroll', [])
  scrollHandler() {
    let number =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (window.location.pathname == '/page-layout/hide-nav') {
      if (number > 600) {
        this.show = true;
      } else if (number === 0) {
        this.show = true;
      } else {
        this.show = false;
      }
    }
  }

  prepareRoute(outlet: RouterOutlet) {
    return (
      outlet &&
      outlet.activatedRouteData &&
      outlet.activatedRouteData['animation']
    );
  }

}
